<template>
  <gj-modal
      size="full"
      :visible.sync="modalVisible"
      @open="modalOpen"
      :contentStyle="{'height': '100%', 'display': 'flex', 'flex-direction': 'column'}"
      :footer="false">
    <template #header>
      商品运营日志
    </template>
    <template #content>
        <div ref="header" class="header"></div>
        <app-base-main
            :table-shadow="false"
            style="flex: 1; overflow: auto; display: flex; flex-direction: column;"
            >
          <template #filter-group>
            <app-filter-group
                :reset="false"
                @query="$gjNoticeQuery"
                @reset="$gjReset">
              <gj-radio-group
                  v-if="dimension === OperationLogEnum.dimension.ASIN && isMeaningful(variationAsin)"
                  v-model="filter.dimension"
                  :options="option.dimension"
                  @input="$gjNoticeQuery">
              </gj-radio-group>
              <gj-select
                  v-model="filter.type"
                  :options="option.type"
                  placeholder="类型"
              ></gj-select>
              <gj-date-picker
                  v-model="filter.date"
                  type="daterange"
                  :shortcut="false"
                  :max-day-length="30"
              ></gj-date-picker>
            </app-filter-group>
          </template>
          <template v-if="$permission('operationLog:add')" #operate-group>
            <gj-button
                type="primary"
                @click="add()">
              添加日志
            </gj-button>
          </template>
          <template #table>
            <gj-table
                ref="gjTable"
                adaptParent
                :index="false"
                name="asinOperationLog"
                :loading="loading"
                :data="tableData"
                :columns="columns"
                :tree-config="filter.dimension === OperationLogEnum.dimension.VARIATION_ASIN ? {children: 'children', indent: 0} : null"
                @sort-change="$gjSortChange"
                @page-change="$gjNoticeQuery">
              <template v-slot:logDate="{row}">
                <template v-if="filter.dimension === OperationLogEnum.dimension.VARIATION_ASIN">
                  <template v-if="isMeaningful(row.children)">{{row.logDate | defaultShow}}</template>
                  <template v-else>{{(row.asin || row.logDate) | defaultShow}}</template>
                </template>
                <template v-else>{{row.logDate | defaultShow}}</template>
              </template>
              <template v-slot:content="{row}">
                <gj-edit-input
                    v-if="$permission('operationLog:add')"
                    :value="row.content"
                    :item="row"
                    table-cell-edit
                    :validator="contentValidator"
                    :on-confirm="updateOperationLog"
                    pop-title="日志内容">
                  {{row.content | defaultShow}}
                </gj-edit-input>
                <template v-else>
                  {{row.content | defaultShow}}
                </template>
              </template>
              <template v-slot:op="{row, index}">
                <gj-button
                    type="text"
                    @click="deleteItem(row, index)">
                  删除
                </gj-button>
              </template>
            </gj-table>
          </template>
        </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import {isMeaningfulMixin, modalMixIn, queryMixin, responseMixin} from "../../../../../../minxins";
  import {OperationLogEnum} from "../../common/enum";
  import {subDays} from 'date-fns';
  import {mapGetters} from "vuex";
  import {getDictionaryCombobox} from "../../../../../../api/common";
  import {convertToDate} from "../../../../../../utils/date.util";
  import {
    deleteOperationLog,
    getAsinOperationLogList,
    getVariationAsinOperationLogList, updateOperationLog
  } from "../../../../../../api/sale";
  import {defaultVal, isMeaningful} from "../../../../../../utils/common";
  import AppAddAsinOperationLogModal from "./modal/add-asin-operation-log-modal";

  export default {
    name: "app-view-asin-operation-log-modal",
    mixins: [modalMixIn, queryMixin, isMeaningfulMixin, responseMixin],
    props: {
      header: {
        required: false,
      },
      dimension: {
        required: true
      },
      marketId: {
        required: true,
      },
      asin: {
        required: true
      },
      variationAsin: {
        type: String
      },
      countryCode: {
        type: String
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'logDate', header: '日期', field: 'slot:logDate', width: '120px'},
          {id: 'type', header: '日志类型', field: 'type', width: '120px'},
          {id: 'content', header: '日志内容', field: 'slot:content', minWidth: '120px'},
          {id: 'createUserName', header: '记录用户', field: 'createUserName', width: '100px'},
          {id: 'updateUserName', header: '最近更新用户', field: 'updateUserName', width: '100px'},
          {id: 'updateTime', header: '最近更新时间', field: 'updateTime', width: '130px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '60px', fixed: 'right', permission: 'operationLog:add', notCustomColumn: true},
        ],
        filter: {
          dimension: OperationLogEnum.dimension.ASIN,
          type: null,
          date: [subDays(new Date(), 14), new Date()]
        },
        option: {
          dimension: OperationLogEnum.dimensionOption,
          type: [],
          typeLoading: false
        },
        OperationLogEnum: OperationLogEnum
      }
    },
    created() {
      this.getTypeOption();
      this.filter.dimension = this.dimension;
      // this.sort.prop = 'updateTime';
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    methods: {
      modalOpen() {
        if (this.header) {
          const {component, props, style} = this.header();
          this.$nextTick(() => {
            this.$gjCreate(component, {
              mountTo: this.$refs.header,
              props,
              style
            }, false);
          });
        }
      },
      $gjQueryInitParams() {
        return {
          filter: {
            dimension: OperationLogEnum.dimension.ASIN,
            type: null,
            date: [subDays(new Date(), 14), new Date()]
          }
        };
      },
      $gjQuery() {
        this.columns[0].id = `logDate${this.filter.dimension}`;
        // 构造查询参数
        const params = {
          marketId: this.marketId,
          dimension: this.filter.dimension,
          type: defaultVal(this.filter.type),
          startLogDate: this.filter.date && this.filter.date.length > 0 ? convertToDate(this.filter.date[0]) : null,
          endLogDate: this.filter.date && this.filter.date.length > 0 ? convertToDate(this.filter.date[1]) : null
        };
        if (this.filter.dimension === OperationLogEnum.dimension.ASIN) {
          params.asin = this.asin;
        } else {
          params.variationAsin = this.variationAsin;
        }
        // this.globalParams = params;
        // 查询
        Promise.resolve(this.filter.dimension)
          .then((dimension) => {
            this.loading = true;
            if (dimension === OperationLogEnum.dimension.ASIN) {
              return getAsinOperationLogList(params);
            } else {
              return getVariationAsinOperationLogList(params);
            }
          })
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data || [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      getTypeOption() {
        this.option.typeLoading = true;
        getDictionaryCombobox('OPERATION_LOG_TYPE')
          .then((data) => {
            this.option.type = data;
          })
          .complete(() => this.option.typeLoading = false);
      },
      add() {
        this.$gjCreate(AppAddAsinOperationLogModal, {
          props: {
            typeOption: this.option.type,
            marketId: this.marketId,
            asin: this.asin,
            dimension: this.filter.dimension,
            variationAsin: this.variationAsin,
            countryCode: this.countryCode
          },
          on: {
            created: () => {
              this.$gjResetPage();
            }
          }
        })
      },
      deleteItem(row) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '删除确认',
            content: `删除后不可恢复，确认删除？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteOperationLog(row.id)
                .then(() => {
                  this.$gjMessage.success('删除成功');
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      contentValidator(content) {
        return isMeaningful(content);
      },
      updateOperationLog(content, row, closeEditor, closeLoading) {
        updateOperationLog({
          id: row.id,
          content,
        })
          .then((res) => {
            this.$gjResponseHandle(res, () => {
              this.$gjMessage.success('操作成功');
              closeEditor();
              this.$gjResetPage();
            });
          })
          .complete(() => closeLoading());
      },
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .base-main{
    padding: 12px 0 0 0 ;
  }
  /deep/ .table{
    flex: 1;
    overflow: auto;
  }
</style>
